import { render } from "./Okrs.vue?vue&type=template&id=420c204e&scoped=true"
import script from "./Okrs.vue?vue&type=script&lang=js"
export * from "./Okrs.vue?vue&type=script&lang=js"

import "./Okrs.vue?vue&type=style&index=0&id=420c204e&lang=scss&scoped=true"

import exportComponent from "/Users/bruno/Documents/projects/pixeon-c/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-420c204e"]])

export default __exports__